<!-- Main Content -->
<div class="container mt-4" >
  <!-- Title with Icon -->
  <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-list mr-2"></i>Kệ
  </h1>

  <!-- Description Below Title -->
  <p class="lead mb-4">
      Quản lý và tổ chức các đơn vị kệ trong hệ thống. Sử dụng các tab để xem tổng quan về việc sử dụng kệ, truy cập danh sách tất cả các kệ hoặc tham khảo hướng dẫn sử dụng. Nhấn "Thêm Kệ" để thêm các đơn vị kệ mới vào hệ thống.
  </p>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs">
      <!-- Removed Overview Tab -->
      <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#List">
              <i class="fas fa-list mr-2"></i> Danh sách
          </a>
      </li>
      <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#UserManual">
              <i class="fas fa-book mr-2"></i> Hướng dẫn sử dụng
          </a>
      </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
      <!-- List tab content -->
      <div id="List" class="tab-pane fade show active">
          <div class="container-fluid" style="background-color: white;">
              <!-- Add Shelf Button -->
              <button class="btn btn-outline-primary btn-icon-split mb-3" (click)="openAddDialog()">
                  <span class="icon text-white-50">
                      <i class="fas fa-plus"></i>
                  </span>
                  <span class="text">Add Shelf</span>
              </button>

              <!-- Refresh Button -->
              <button class="btn btn-outline-secondary btn-icon-split mb-3 ml-2" (click)="refreshData()">
                  <span class="icon text-white-50">
                      <i class="fas fa-sync-alt"></i>
                  </span>
                  <span class="text">Refresh</span>
              </button>

              <!-- Search Input -->
              <div class="mb-3">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Search by name..."
                      (input)="updateFilter($event)"
                  />
              </div>

              <!-- Loading Indicator -->
              <div *ngIf="loadingIndicator; else loaded">
                <app-loading></app-loading>
              </div> 
              
              <ng-template #loaded>
                  <ngx-datatable
                      class="bootstrap"
                      [rows]="shelves"
                      [columnMode]="'force'"
                      [headerHeight]="50"
                      [footerHeight]="50"
                      [rowHeight]="'auto'"
                      [limit]="10"
                      [loadingIndicator]="loadingIndicator"
                      [reorderable]="reorderable"
                      (select)="onSelect($event)"
                      (activate)="onActivate($event)"
                  >
                      <!-- Shelf Name -->
                      <ngx-datatable-column name="Shelf Name" [prop]="'shelfName'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                             <span style="color: red;">{{ row.shelfName }}</span> 
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Shelf Code -->
                      <ngx-datatable-column name="Shelf Code" [prop]="'shelfCode'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                            <span style="color: blue;">{{ row.shelfCode }}</span>
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Location -->
                      <ngx-datatable-column name="Location" [prop]="'location'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                              {{ row.location }}
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Capacity -->
                      <ngx-datatable-column name="Capacity" [prop]="'capacity'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                              {{ row.capacity }}
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Material -->
                      <ngx-datatable-column name="Material" [prop]="'material'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                              {{ row.material }}
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Color -->
                      <ngx-datatable-column name="Color" [prop]="'color'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                              {{ row.color }}
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Department -->
                      <ngx-datatable-column name="Department" [prop]="'department.departmentName'">
                          <ng-template ngx-datatable-cell-template let-row="row">
                            <span style="color: green;">{{ row.department?.departmentName }}</span>
                          </ng-template>
                      </ngx-datatable-column>

                      <!-- Actions -->
                      <ngx-datatable-column name="Actions">
                          <ng-template ngx-datatable-cell-template let-row="row">
                            <button class="btn btn-sm btn-outline-primary dropdown-toggle btn-sm" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                Actions
                              </button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <li>
                                  <a class="dropdown-item"  (click)="openEditDialog(row)">
                                    <i class="fas fa-edit"></i> Edit
                                  </a>
                                </li>
                                <li>
                                  <a class="dropdown-item"  (click)="deleteRow(row.id)">
                                    <i class="fas fa-trash"></i> Delete
                                  </a>
                                </li>
                              </ul>
                          </ng-template>
                      </ngx-datatable-column>
                  </ngx-datatable>
              </ng-template>
          </div>
      </div>

      <!-- User Manual tab content -->
      <div id="UserManual" class="tab-pane custom-tab-pane">
        <!-- User Manual content here -->
        <div>
           <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
            <div  [innerHTML]="markdownContent"></div>
        </div>
      </div>
  </div>
</div>
